module.exports = __webpack_public_path__ + "img/empty_fav.9e7351db.svg";